import React from 'react';
import { RiPlaneLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { MODE } from '@/define/robotStatus';

const Panel = ({ data: robots }) => {
  return (
    <Mode
      data={robots}
      modeId={MODE.ARDUPILOT.COPTER.STABILIZE.id}
      desc="Manual control with attitude stabilization only"
    />
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Stabilize';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPlaneLine;
Command.Panel = Panel;

export default Command;
